import type {ApiConfig} from './config.base';

export const config: ApiConfig = {
    BASE_URL: 'https://api.gptforme.com',
    TIMEOUT: 30000,
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000,
};